export default (product_url) => {
  return new Promise((resolve) => {
    $.ajax({
      cache: false,
      url: product_url,
      data: {},
      success: () => {
        // console.log(`[200] ${product_url}`);
        resolve(true);
      },
      error: (xhr, textStatus, errorThrown) => {
        if (xhr.status === 404 || errorThrown === 'Not Found') {
          // console.log(`[404] ${product_url}`, errorThrown);
          resolve(false);
        }

        resolve(true);
      },
    });
  });
};
